import { createAction } from "typesafe-actions";

import type {
  FiChartSummary,
  FiChartSummaryPayload,
} from "@mapmycustomers/shared/types/entity/fieldInsight";

export const fetchFieldInsightsChartSummary = createAction("@fieldInsightsChartSummary/fetch")<{
  callback: (tables: FiChartSummary[]) => void;
  failureCallback?: () => void;
}>();

export const updateFieldInsightsChartSummary = createAction("@fieldInsightsChartSummary/update")<{
  callback: (table: FiChartSummary) => void;
  data: FiChartSummaryPayload;
  failureCallback?: () => void;
  tableId: FiChartSummary["id"];
}>();
